module.exports = __webpack_public_path__ + "img/employer_signup_hero.359af925.jpg";